import type {
  SchemaOperator,
  SchemaOperatorEmpty,
  SchemaOperatorNumeric,
  SchemaOperatorString,
} from "./schema.type";

export const SCHEMA_NUMERIC_OPERATORS: SchemaOperatorNumeric[] = [
  "==",
  "!=",
  "<",
  ">",
  "<=",
  ">=",
];

export const SCHEMA_STRING_OPERATORS: SchemaOperatorString[] = ["contains"];

export const SCHEMA_EMPTY_OPERATORS: SchemaOperatorEmpty[] = [
  "isEmpty",
  "isNotEmpty",
];

export const SCHEMA_OPERATORS: SchemaOperator[] = [
  ...SCHEMA_NUMERIC_OPERATORS,
  ...SCHEMA_STRING_OPERATORS,
  ...SCHEMA_EMPTY_OPERATORS,
];
